import * as React from 'react'
import { sbEditable, SbEditableBlok } from '@storyblok/storyblok-editable'
import styled from 'styled-components'
import { Autoplay, SwiperOptions } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import { SbAsset } from '../../types'

const StyledWrapper = styled.div`
  line-height: 0;
  padding: 6rem 0;

  .swiper {
    margin-bottom: 2rem;

    &:last-child {
      margin-bottom: 0;
    }

    &-wrapper {
      transition-timing-function: linear !important;
    }

    &-slide {
      width: auto;
    }
  }
`

const StyledImageWrapper = styled.div`
  display: inline-block;
  padding: 0 1rem;
`

const StyledImage = styled.img`
  border-radius: 1.5rem;
  height: 9rem;
  width: 9rem;

  @media screen and (min-width: 768px) {
    height: 11rem;
    width: 11rem;
  }
`

export interface ImageCarouselProps {
  blok: SbEditableBlok & {
    upperImages: SbAsset[]
    lowerImages: SbAsset[]
  }
}

const swiperOptions: SwiperOptions = {
  modules: [Autoplay],
  spaceBetween: 0,
  loop: true,
  allowTouchMove: false,
  slidesPerView: 'auto',
  centeredSlides: true,
  loopedSlides: 5,
  loopedSlidesLimit: false,
  speed: 4000,
  autoplay: {
    delay: 0,
  },
}

export const ImageCarousel = ({ blok }: ImageCarouselProps) => {
  const upperImageCarouselItems = blok.upperImages
  const lowerImageCarouselItems = blok.lowerImages

  return (
    <StyledWrapper {...sbEditable(blok)}>
      <Swiper {...swiperOptions} autoplay={{ delay: 0, reverseDirection: true }}>
        {upperImageCarouselItems.map(upperImageCarouselItem => (
          <SwiperSlide key={upperImageCarouselItem.id}>
            <StyledImageWrapper>
              <StyledImage src={upperImageCarouselItem.filename} alt={upperImageCarouselItem.alt} />
            </StyledImageWrapper>
          </SwiperSlide>
        ))}
      </Swiper>
      <Swiper {...swiperOptions}>
        {lowerImageCarouselItems.map(lowerImageCarouselItem => (
          <SwiperSlide key={lowerImageCarouselItem.id}>
            <StyledImageWrapper>
              <StyledImage src={lowerImageCarouselItem.filename} alt={lowerImageCarouselItem.alt} />
            </StyledImageWrapper>
          </SwiperSlide>
        ))}
      </Swiper>
    </StyledWrapper>
  )
}
